module.exports = __webpack_public_path__ + "img/cover.6dc35e6b.jpg";